function get(key){
    const value = localStorage.getItem(key);
    try{
        return JSON.parse(value);
    }
    catch{
        return value;
    }
}

function set(key,data){
    localStorage.setItem(key,JSON.stringify(data));
}

export default{
    get,
    set
}